import { CmsTileProps } from "components/partial/cms/cms-table/cms-table";
import { IGroupProfileItemModel } from "models/dto/ZoomiLxp/Models/GroupModels/IGroupProfileItemModel";
import { CertificateLink, CompletionCell, GroupsCertificationsName, RequirementCell } from "./data";
import styles from "./styles.module.scss";

const MyGroupsCertificationsTile = ({ item }: CmsTileProps<IGroupProfileItemModel>) => (
	<div className={styles.groups_certifications_tile}>
		<div className={styles.groups_certifications_tile__main}>
			<GroupsCertificationsName item={item} />
		</div>
		<div className={styles.groups_certifications_tile__certificate}>
			<CertificateLink url={item.certificateUrl} />
		</div>
		<div className={styles.groups_certifications_tile__row}>
			<span>Group name</span>
			<span>{item.groupName}</span>
		</div>
		<div className={styles.groups_certifications_tile__row}>
			<span>Courses</span>
			<span>{item.courseCount}</span>
		</div>
		<div className={styles.groups_certifications_tile__row}>
			<span>Completion</span>
			<CompletionCell item={item} />
		</div>
		<div className={styles.groups_certifications_tile__row}>
			<span>Z1</span>
			<RequirementCell requirement={item.z1Requirement} />
		</div>
		<div className={styles.groups_certifications_tile__row}>
			<span>Engagement</span>
			<RequirementCell requirement={item.engagementRequirement} />
		</div>
		<div className={styles.groups_certifications_tile__row}>
			<span>Exam pass %</span>
			<RequirementCell requirement={item.examRequirement} />
		</div>
	</div>
);

export default MyGroupsCertificationsTile;
